import React, { useState } from 'react';
import './App.css';
import SideandSearchBar from './components/SideandSearchBar/SideandSearchbar';
import OnSearch from './components/onSearch/onSearch';


function App() {

  const[searchedquery, setsearchedquery] = useState('');
  const[pageToken,setpageToken] = useState('');

  const handleSearchSubmit = (searchterm)=>{
    setsearchedquery(searchterm);
    setpageToken('');
  }

  const handlepageToken = (token)=>{
    setpageToken(token);
  }

  return (
    <div className="App">
      <SideandSearchBar onSearchSubmit={handleSearchSubmit} />
      <OnSearch searchedquery={searchedquery} pageToken={pageToken} handlepageToken={handlepageToken} />
    </div>
  );
}

export default App;

// const handleSearchSubmit = async (searchterm)=>{
//   const res = await youtube.get('search', {
//     params: {
//       part: 'snippet',
//       maxResults: 5,
//       q: searchterm,
//       key: 'AIzaSyDyJEXZRvPJkm1zzgEroc-uXcBLuTAMCgY'
//   }
//   });
//   setsearchedvideo(res.data.items);
// }
